const regular = {
    manageUsers: false,
    provideFeedback: true,
    configureApp: false,
    appGeneralSettings: false,
    viewAppasOtherRolesinPublish: false,
    lookupRights: "Access",
    dashboardingRights: "Access",
    reportingRights: "Access",
    viewAppasOtherRoles: false,
    configureAppinPreview: false,
    importRights: false,
    dataAccessRights: false,
    importRightsinPreview: false,
    notificationRights: "Access",
    sharedFormRights: "Access",
    globalHistoryRights: "Access",
    apiRights: false,
    allowTaskWorkflowManagement: "Access",
    internalWorkflowRights: "Access",
    allowCopilotManagement: "No access",
    globalSearchRights: "Access",
    historyReportingRights: "No access",
    commentReportingRights: "No access",
    formDefinitionRights: "No access"
}

const limited = {
    manageUsers: false,
    provideFeedback: false,
    configureApp: false,
    appGeneralSettings: false,
    viewAppasOtherRolesinPublish: false,
    lookupRights: "No access",
    dashboardingRights: "No access",
    reportingRights: "No access",
    viewAppasOtherRoles: false,
    configureAppinPreview: false,
    importRights: false,
    dataAccessRights: false,
    importRightsinPreview: false,
    notificationRights: "No access",
    sharedFormRights: "Access",
    globalHistoryRights: "No access",
    apiRights: false,
    allowTaskWorkflowManagement: "No access",
    internalWorkflowRights: "No access",
    allowCopilotManagement: "No access",
    globalSearchRights: "No access",
    historyReportingRights: "No access",
    commentReportingRights: "No access",
    formDefinitionRights: "No access"
}

export const roleDataByType = {
    "Regular": regular,
    "Limited": limited
}